import { trackEvent } from '@/core/analytics'

const SCREEN = { screenName: 'login', screenType: 'page' }
const FORGOT_SCREEN = {
  screenName: 'forgotPassword',
  screenType: 'page',
}

// --- Login ---

export function trackLoginScreenView() {
  trackEvent('screenView', SCREEN)
}

export function trackLoginEmailClicked() {
  trackEvent('emailClicked', {
    ...SCREEN,
    elementType: 'inputEmail',
    elementName: 'email',
  })
}

export function trackLoginPasswordClicked() {
  trackEvent('passwordClicked', {
    ...SCREEN,
    elementType: 'inputPassword',
    elementName: 'password',
  })
}

export function trackLoginContinueClicked() {
  trackEvent('continueClicked', {
    ...SCREEN,
    elementType: 'button',
    elementName: 'continue',
  })
}

export function trackLoginForgotPasswordClicked() {
  trackEvent('forgotPasswordClicked', {
    ...SCREEN,
    elementType: 'button',
    elementName: 'forgotPassword',
  })
}

export function trackUserSignedIn() {
  trackEvent('userSignedIn', {
    ...SCREEN,
    loginType: 'login',
  })
}

export function trackAutologinSuccess() {
  trackEvent('autologinSuccess', SCREEN)
}

export function trackUserHasErrorOnLogin() {
  trackEvent('userHasErrorOnLogin', SCREEN)
}

export function trackLoginSupportClicked() {
  trackEvent('supportClicked', {
    ...SCREEN,
    elementType: 'button',
    elementName: 'supportContact',
  })
}

// --- Forgot Password ---

export function trackForgotPasswordScreenView() {
  trackEvent('screenView', FORGOT_SCREEN)
}

export function trackForgotPasswordEmailClicked() {
  trackEvent('emailClicked', {
    ...FORGOT_SCREEN,
    elementType: 'inputEmail',
    elementName: 'email',
  })
}

export function trackForgotPasswordSendClicked() {
  trackEvent('sendMailClicked', {
    ...FORGOT_SCREEN,
    elementType: 'button',
    elementName: 'sendMail',
  })
}

export function trackForgotPasswordSuccess() {
  trackEvent('mailSendRequestSuccess', FORGOT_SCREEN)
}

export function trackForgotPasswordSupportClicked() {
  trackEvent('contactSupportClicked', {
    ...FORGOT_SCREEN,
    elementType: 'button',
    elementName: 'contactSupport',
  })
}

// --- Change password ---

const CHANGE_PASSWORD_SCREEN = {
  screenName: 'changePassword',
  screenType: 'page',
}

export function trackChangePasswordScreenView() {
  trackEvent('screenView', CHANGE_PASSWORD_SCREEN)
}

export function trackChangePasswordUpdateClicked() {
  trackEvent('buttonClicked', {
    ...CHANGE_PASSWORD_SCREEN,
    elementType: 'button',
    elementName: 'updatePassword',
  })
}

export function trackPasswordUpdated() {
  trackEvent('passwordUpdated', CHANGE_PASSWORD_SCREEN)
}

/** Same reason vocabulary as the phones: tooShort, sameAsCurrent, mismatch,
 *  wrongCurrentPassword, transport. */
export function trackPasswordUpdateFailed(reason: string) {
  trackEvent('passwordUpdateFailed', { ...CHANGE_PASSWORD_SCREEN, reason })
}
